<template>
  <v-layout row wrap fill-height align-center justify-center class="py-5">
    <v-flex xs12 sm10 md10 lg8 xl6>
      <v-card>
        <v-card-text class="pa-4">
          <h2 class="display-1 mb-4">Shrnutí objednávky</h2>

          <v-alert :value="warringOpen" outline color="error" icon="warning">
            Byla překročena skladová zásoba. Prosím vraťte se na <router-link :to="{ path: '/step-2'}" replace>krok dva</router-link> a upravte informace.
          </v-alert>

          <v-alert :value="errorResponse" outline color="error" icon="warning">
            Při vytváření objednávky se vyskytla chyba, kontaktujte prosím správce webu.<br>
            Rezervace je možná na telefonu: <a href="tel:+420603587102">+420&nbsp;603&nbsp;587&nbsp;102</a>
          </v-alert>

          <v-alert :value="alredySend && !warringOpen && !errorResponse" outline color="success" icon="warning">
            Připravuji objednávku. Prosím počkejte.
          </v-alert>

          <v-container fluid grid-list-xl class="pa-0">
            <v-layout row wrap fill-height align-content-start justify-center>
              <v-flex xs12 lg6 xl6 class="mb-4">
                <h3 class="headline mb-3">Objednávka</h3>
                <v-data-table
                  :items="orderSummary"
                  hide-actions
                  class="elevation-1"
                  hide-headers
                >
                  <template slot="items" slot-scope="props">
                    <td v-html="props.item.label"></td>
                    <td class="text-xs-right">{{ props.item.val }}</td>
                  </template>
                </v-data-table>
              </v-flex>
              <v-flex xs12 lg6 xl6 class="mb-4">
                <h3 class="headline mb-3">Zákazník</h3>
                <v-data-table
                  :items="customerSummary"
                  hide-actions
                  class="elevation-1"
                  hide-headers
                >
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.label }}</td>
                    <td class="text-xs-right">{{ props.item.val }}</td>
                  </template>
                </v-data-table>

                <h3 class="headline pt-4 mb-3">Cena</h3>
                <v-data-table
                  :items="priceSummary"
                  hide-actions
                  class="elevation-1"
                  hide-headers
                >
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.label }}</td>
                    <td class="text-xs-right">{{ props.item.val }}</td>
                  </template>
                </v-data-table>
              </v-flex>
            <p class="gdpr-text">Odesláním objednávky souhlasím s <a href="http://sup-pardubice.cz/navstevni-rad/" target="_blank" rel="nofollow">provozním řádem</a> a beru na vědomí <a href="http://sup-pardubice.cz/osobni-udaje/" target="_blank" rel="nofollow">zpracování osobních údajů</a>.</p>
            </v-layout>
          </v-container>

          <v-layout row wrap fill-height align-center justify-space-between>
            <v-btn
              class="ma-0"
              color="primary"
              @click="back"
            >Zpět
            </v-btn>

            <v-btn
              :disabled="warringOpen || alredySend"
              class="ma-0"
              color="primary"
              @click="next"
            >Objednat
            </v-btn>
          </v-layout>

        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import Footer from '@/components/Footer'
  import moment from 'moment-timezone';

  export default {
    components: {
      'footer-nav': Footer
    },
    data() {
      return {
        warringOpen: false,
        alredySend: false,
        errorResponse: false,
      }
    },
    computed: {
      customerSummary() {
        let c = this.$store.getters.getCustomer;

        return [
          {label: 'Jméno', val: c.name},
          {label: 'E-mail', val: c.email},
          {label: 'Telefon', val: c.telephone},
          {label: 'Město', val: c.city},
        ]
      },
      orderSummary() {
        let o = this.$store.getters.getOrder;
        let s = this.$store.getters.sluzba;

        let arr = [
          {label: 'Datum konání', val: moment(o.datumKonani + ' ' + o.konaniOd).format('DD. MM. YYYY - HH:mm')},
          {label: 'Datum konání do', val: moment(o.datumKonaniDo + ' ' + o.konaniDo).format('DD. MM. YYYY - HH:mm')},
//                    {label: 'Od', val: o.konaniOd},
//                    {label: 'Do', val: o.konaniDo},
          {label: 'Místo vyzvednutí', val: o.mistoVyzvednuti},
          {label: 'Místo odevzdání', val: o.mistoOdevzdani},
          {label: 'Počet paddleboardů', val: o.pocetPrken + ' ks'},
          {label: 'Počet vest', val: o.pocetVest + ' ks'},
          // {label: 'Počet vodních světů', val: o.pocetVodnichSvetu + ' ks'},
//                    {label: 'Počet pádel', val: o.pocetPadel + ' ks'},
        ];

        if (s.typ !== "action") {
          arr.push({label: 'Počet vstupenek do <br>"FUN WATER PARK"', val: o.pocetVodnichSvetu + ' ks'});
          arr.push({label: 'Počet šlapadel', val: o.pocetSlapadel + ' ks'});
          arr.push({label: 'Počet lodí', val: o.pocetLodi + ' ks'});
        }

          arr.push({label: 'Počet kanoí', val: o.pocetKanoi + ' ks'});

        if (s.typ !== "action") {
          arr.push({label: 'Počet koloběžek', val: o.pocetKolobezek + ' ks'});
        }

        if (o.dopravaKolobezka) {
          arr.push({label: 'Počet koloběžek', val: o.pocetDopravKolobezka + ' ks'});
        }

        if (o.doprava) {
          arr.push({label: 'Počet doprav', val: o.pocetDoprav + ' ks'});
        }

        return arr;
      },
      priceSummary() {
        let o = this.$store.getters.getOrder;

        if (o.doprava || o.dopravaKolobezka) {
          let price_summary = [];

          if(o.cenaZaPrkna){
            price_summary.push({label: 'Cena za prkna', val: o.cenaZaPrkna + ' Kč'},);
          }

          if(o.cenaZaDopravuKolobezka){
            price_summary.push({label: 'Cena za koloběžky', val: o.cenaZaDopravuKolobezka + ' Kč'},);
          }

          if(o.cenaZaDopravu){
            price_summary.push({label: 'Cena za dopravu', val: o.cenaZaDopravu + ' Kč'},);
          }
            price_summary.push({label: 'Cena celkem', val: o.cenaCelkem + ' Kč'},);

          return price_summary;
        }

        return [
          {label: 'Cena celkem', val: o.cenaCelkem + ' Kč'},
        ]
      },
      paySummary() {


        let p = this.$store.getters.getPayType;

        return [
          {label: 'Platba', val: p.city},
        ]
      },
    },
    methods: {
      getReadableValue(key) {
        switch (key) {

        }
      },
      back() {
        this.$store.commit('setActualStep', 4);
        this.$router.push('step-4');
      },
      next() {
        this.alredySend = true;
        this.$store.dispatch('completeOrder').then(response => {
          this.$router.push('step-6');
        }).catch(err => {
          if(err.response && err.response.status == 409){
            this.warringOpen = true;
          }else{
            this.errorResponse = true;
          }
        });
      }
    },
    mounted() {

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Step5.vue